export default __webpack_public_path__ + "static/media/01.af504dc3.jpg";